<template>
  <div class="edit-platform">
    <!--标题-->
    <!-- <div class="breadcrumb" style="background: #fff">申请线下充值</div> --> {{ $route.query.applyType }} <div class="breadcrumb" style="background: #fff">{{ $route.query.applyType == 'OPEN' ? '申请充值' :
      $route.query.applyType == 'RENEW' ? '续费' : '审核' }}</div>
    <div class="order-detail-basic">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" hide-required-asterisk label-width="160px" class="demo-ruleForm">
        <!-- <el-form-item label="支付日期:" prop="payTime"> -->
        <el-form-item label="付款日期:" prop="payTime">
          <el-date-picker v-model="ruleForm.payTime" :picker-options="pickerOptions0" type="datetime" style="width: 200px !important;" placeholder="选择日期" format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss" :disabled="disabled">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="平台号:" prop="num" v-if="$route.query.applyType != 'RENEW'">
          <div v-if="!$route.query.id">
            <el-autocomplete v-model="code" :fetch-suggestions="querySearchAsync" placeholder="请输入内容" :trigger-on-focus="false" @select="handleSelect">
            </el-autocomplete>
            <el-button @click="verifyStore" style="margin-right:10px" round>验证平台</el-button>
            <span v-show="show">平台名称:{{ storeName }}</span>
          </div>
          <span v-else>{{ ruleForm.storeCode }} <span style="margin-left: 200px;">平台名称:{{ ruleForm.storeName }}</span></span>
        </el-form-item>
        <el-form-item label="平台号:" prop="num" v-else>
          <el-input v-model="ruleForm.storeCode" clearable :disabled="true"></el-input>
          <span>平台名称:{{ storeName }}</span>
        </el-form-item>
        <el-form-item label="充值金额:" prop="money">
          <el-input v-model="ruleForm.money" clearable :disabled="disabled"></el-input>
        </el-form-item>
        <el-form-item label="套餐类型:" prop="planId">
          <el-select v-model="ruleForm.planId" placeholder="请选择" clearable :disabled="disabled">
            <el-option v-for="item in membershipNameList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否定制专属小程序：" v-if="ruleForm.planId">
          <el-switch v-model="ruleForm.miniProgram" :active-value="1" :inactive-value="0" :disabled="disabled">
          </el-switch>
        </el-form-item>
        <el-row>
          <el-col :span="7">
            <el-form-item label="收款账户:" prop="receAccount">
              <el-select v-model="ruleForm.receAccount" placeholder="请选择" @change="bankAccountChange" clearable :disabled="disabled">
                <el-option v-for="item in bankList" :key="item.bankAccountId" :label="item.bankName" :value="item.bankAccountId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="账户号:" style="margin-left: 1px;">
              <el-input v-model.number="ruleForm.account" type="number" clearable :disabled="disabled"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="交易单号:" prop="transactionNumber">
          <el-input v-model="ruleForm.transactionNumber" type="number" clearable :disabled="disabled"></el-input>
        </el-form-item>
        <el-form-item label="支付凭证:">
          <div class="upload-img" v-if="!disabled">
            <input type="file" name="" id="input_img" @change="upload($event)" />
            <div class="recharge-ok">上传文件</div>
          </div>
          <div id="show_img">
            <img :src="voucher" alt="">
          </div>
          <p style="color: #999">支持格式：.jpg.png ，单个文件不能超过10MB，再次上传将替换</p>
        </el-form-item>
        <el-form-item label="备注:">
          <el-input v-model="ruleForm.remark" clearable :disabled="disabled"></el-input>
        </el-form-item>
      </el-form>
      <div class="edit-button" style="justify-content:flex-end; padding-left:120px;">
        <el-button type="primary" round @click="submitForm('ruleForm')" :loading="loading" v-if="!$route.query.id">申请会员</el-button>
        <el-button round @click="IsReject = true" :loading="loading" v-if="$route.query.id && $route.query.type == 2">审核拒绝</el-button>
        <el-button type="primary" round @click="auditForm(true)" :loading="loading" v-if="$route.query.id && $route.query.type == 2">审核通过</el-button>
        <el-button type="primary" round @click="$router.go(-1)" v-if="$route.query.id">返回</el-button>
      </div>
    </div>
    <CombinedDialog ref="dialogRef"></CombinedDialog>
    <el-dialog :close-on-click-modal="false" title='原因' :visible.sync='IsReject' width="30%">
      <el-input v-model="approve" type="textarea" clearable></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="IsReject = false">取 消</el-button>
        <el-button type="primary" @click="auditForm(false)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import imgSrc from '@/assets/images/money.svg'
import CombinedDialog from '@/components/Dialog/CombinedDialog/index'
import { chargeApply, bankAccountGetAll } from '@/api/epay'
import { storeQueryListByCode, storeQueryByStoreCode, videoMembership, getNameList, applyMembership, videoMembershipAudit, getMemberShipList, queryMembershipById } from '@/api/crm'
import uploadWebImg, { getAwsSdk } from '@/utils/uploadWebImg'
export default {
  name: 'edit-platform',
  components: {
    CombinedDialog
  },
  data () {
    // 校验充值金额
    var checkAmount = (rule, value, callback) => {
      // const regAmount = /^[1-9]\d*$/
      console.log('valuevaluevalue', value)
      const regAmount = /^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/
      if (value === '') {
        callback(new Error('请输入充值金额'))
      } else if (regAmount.test(value)) {
        return callback()
      } else {
        // callback(new Error('请输入正整数(不包括0)'))
        callback(new Error('请输入正数且小数点后精度两位'))
      }
    }
    // var receAccount = (rule, value, callback) => {
    //   if (this.ruleForm.money !== '0' && !this.ruleForm.receAccount) {
    //     callback(new Error('请选择收款账户'))
    //   } else {
    //     callback()
    //   }
    // }
    // var transactionNumber = (rule, value, callback) => {
    //   if (this.ruleForm.money !== '0' && !this.ruleForm.transactionNumber) {
    //     callback(new Error('请输入交易单号'))
    //   } else {
    //     callback()
    //   }
    // }
    return {
      disabled: !!this.$route.query.id,
      IsReject: false,
      approve: '',
      membershipNameList: [],
      voucher: '',
      loading: false,
      awsSdk: null,
      show: false,
      storeName: '',
      ruleForm: {
        account: '',
        miniProgram: 0,
        // accountType: 'ACCT', // 需要充值的账户类型
        money: '', // 充值金额
        planId: '', // 套餐id
        receAccount: '', // 收款账户
        payTime: '', // 支付日期
        payPhotoList: [], // 支付凭证
        // bonus: '',
        remark: '', // 备注
        storeId: '',
        transactionNumber: '', // 交易单号
        // paymentChannel: 'OFFLINE',
        // originType: 'WEB'
        applyType: this.$route.query.applyType// 申请类型
      },
      rules: {
        payTime: [
          { required: true, message: '请选择日期', trigger: 'change' }
        ],
        money: [
          { validator: checkAmount, trigger: 'change' }
        ],
        planId: [{ required: true, message: '请选择套餐类型', trigger: 'change' }]
        // bonus: [
        //   { required: true, message: '请填写虚拟充值', trigger: 'blur' }
        // ],
        // receAccount: [
        //   { validator: receAccount, trigger: 'change' }
        // ],
        // transactionNumber: [
        //   { validator: transactionNumber, trigger: 'blur' }
        // ]
      },
      date: '',
      code: '', // 平台号
      bankList: [],
      pickerOptions0: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        }
      }
    }
  },
  watch: {
    date (val) {
      if (val) {
        this.ruleForm.payTime = this.$moment(this.date).format('YYYY-MM-DD HH:mm:ss')
      } else {
        this.ruleForm.payTime = ''
      }
    },
    code () {
      this.show = false
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  async created () {
    if (this.$checkAwsSdk('product')) this.$store.dispatch('awsSdk/getAwsSdk', 'product')
    await this.getBankList()
    this.getMembershipNameList()
    if (this.$route.query.id) {
      this.getApplyMembership()
    }
    if (this.$route.query.renewId) {
      this.getQueryMembershipById()
    }
  },
  methods: {
    getApplyMembership () {
      applyMembership(this.$route.query.id).then(res => {
        if (res.data.success) {
          this.ruleForm = res.data.data
          this.ruleForm.receAccount = Number(res.data.data.receAccount)
          this.voucher = res.data.data.payPhotoList[0]
        }
      })
    },
    getQueryMembershipById () {
      queryMembershipById(this.$route.query.renewId).then(res => {
        if (res.data.success) {
          this.ruleForm.storeId = res.data.data.storeId
          this.ruleForm.storeCode = res.data.data.code
          this.storeName = res.data.data.shopName
          this.show = true
        }
      })
    },
    // 获取套餐类型列表
    getMembershipNameList () {
      getMemberShipList({ name: '', systemCode: this.$route.query.systemCode, pageSize: 9999, pageNum: 1 }).then(res => {
        this.membershipNameList = res.data.data.records.filter(a => a.freePlan != 1 && a.show == 1)
      })
    },
    // 获取收款账户列表
    async getBankList () {
      await bankAccountGetAll().then(res => {
        this.bankList = res.data.data
      })
    },
    // 验证平台
    verifyStore () {
      this.code = this.code.replace(/\s*/g, '')
      if (!this.code) {
        this.$message.error('请输入平台号')
        return
      }
      storeQueryByStoreCode(this.code).then(res => {
        if (res.data.data.exist) {
          if (res.data.data.membershipList?.length > 0) {
            this.ruleForm.storeId = res.data.data.id
            this.storeName = res.data.data.name
            this.show = true
          } else {
            this.$message.error('影像季店铺信息不存在')
          }
        } else {
          this.$message.error('店铺不存在')
        }
      })
    },
    handleAvatarSuccess (res, file) {
      this.imageUrl = URL.createObjectURL(file.raw)
    },
    submitForm (formName) {
      if (!this.show) {
        this.$message.error('请验证平台')
        return
      }
      this.$refs[formName].validate((valid) => {
        console.log(this.ruleForm, 'formName')
        if (valid) {
          if (!this.voucher) {
            this.$message({
              message: '请上传支付凭证',
              type: 'error'
            })
            return
          };
          this.loading = true
          this.ruleForm.payPhotoList = [this.voucher]
          // chargeApply(false, this.ruleForm).then(res => {
          videoMembership(this.ruleForm).then(res => {
            if (res.data.success) {
              this.$message({
                message: '申请成功',
                type: 'success'
              })
              // this.$router.push({
              //   path: '/videoSeason/examine'
              // })
              this.$router.go(-1)
              this.loading = false
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    auditForm (val) {
      videoMembershipAudit({ approve: val, id: Number(this.$route.query.id), refuseReason: this.approve }).then(res => {
        if (res.data.success) {
          this.IsReject = false
          this.$message({
            message: '审核完成',
            type: 'success'
          })
          this.$router.push({
            path: '/videoSeason/examine'
          })
        }
      })
    },
    upload (e) {
      console.log(e)
      const loading = this.$loading({
        lock: true,
        text: '正在上传',
        spTEXT: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      if (e.target.files[0].size === 0) {
        this.$message.error('该图片是一个空文件夹，无法上传')
        loading.close()
        return
      }
      if (e.target.files[0].type !== 'image/jpeg' && e.target.files[0].type !== 'image/png') {
        this.$message.error('请上传jpeg/png格式的图片')
        loading.close()
        return
      }

      if (e.target.files[0].size > 1024 * 1024 * 10) {
        this.$message.error('图片大小不能超过10M')
        loading.close()
        return
      }
      var file = e.target.files[0]
      uploadWebImg(file, this.$store.state.awsSdk.product.s3).then(res => {
        this.voucher = res
        loading.close()
      })
    },
    handleSelect (item) {
      this.ruleForm.storeId = item.id
    },
    querySearchAsync (queryString, cb) {
      console.log('querySearchAsync', queryString.length)
      let data = queryString.trim()
      if (data !== '') {
        storeQueryListByCode(data, this.$route.query.systemCode).then(res => {
          res.data.data.forEach(item => {
            item.value = item.code
          })
          let dataList = res.data.data.filter(res => res.membershipList && res.membershipList.length > 0)
          cb(dataList)
        })
      }
    },
    // 选择银行
    bankAccountChange (val) {
      console.log('11111', val)
      let findBank = this.bankList.find(res => res.bankAccountId === val)
      this.ruleForm.receAccount = val
      this.ruleForm.account = findBank.cardNo
    }
  }
}
</script>
<style scoped lang="less">
// @import "index";
.edit-platform {
  .el-input {
    @{deep} .el-input__inner {
      //color: #F56C6C;
      -moz-appearance: textfield;
    }

    @{deep} .el-input__inner::-webkit-inner-spin-button,
    @{deep} .el-input__inner::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
}

@deep: ~">>>";
</style>
